/* eslint-disable sort-destructure-keys/sort-destructure-keys */
import htmlReactParser, { domToReact } from 'html-react-parser'
import React from 'react'

import LinkComponent from '../LinkComponent/LinkComponent'

const sanitizeText = (text) => {
  // Add custom sanitization logic here
  return text.replace(/<\/?[^>]+(>|$)/g, '') // Example: Remove all HTML tags
}

const siteUrl = `https://essentialaesthetics.nl`

// Function to convert style string to style object
const parseStyleString = (styleString) => {
  return styleString.split(';').reduce((acc, styleProperty) => {
    const [property, value] = styleProperty
      .split(':')
      .map((item) => item.trim())
    if (property && value) {
      acc[property] = value
    }
    return acc
  }, {})
}

// Function to convert attributes array to object
const attributesToObject = (attributes) => {
  return attributes.reduce((acc, attr) => {
    acc[attr.name] = attr.value
    return acc
  }, {})
}

const richTextRenderer = (htmlString) => {
  const options = {
    replace: (domNode) => {
      if (domNode.type === 'tag' && domNode.name === 'a') {
        const { href, style } = domNode.attribs
        const styleObject = style ? parseStyleString(style) : {}
        const newHref = href.includes(siteUrl) ? href.split(siteUrl)[1] : href
        return (
          <LinkComponent src={newHref} style={styleObject}>
            {domToReact(domNode.children)}
          </LinkComponent>
        )
      }
      if (domNode.type === 'text') {
        return sanitizeText(domNode.data)
      }
      if (domNode.type === 'tag' && domNode.name === 'img') {
        const attributes = attributesToObject(domNode.attributes)
        const { 'data-src': dataSrc, alt, style, ...rest } = attributes
        const newSrc = dataSrc || attributes.src || ''
        const styleObject = style ? parseStyleString(style) : {}
        return <img src={newSrc} style={styleObject} {...rest} alt={alt} />
      }
      return null
    },
  }

  return <>{htmlReactParser(htmlString, options)}</>
}

export default richTextRenderer
